<template><div><h1>Thanks</h1>
<h2>VUX 参考或者使用了以下开源项目的代码</h2>
<ul>
<li><a href="https://github.com/vuejs/vue">Vue</a></li>
<li><a href="https://github.com/weui/weui">WeUI</a></li>
<li><a href="https://github.com/frozenui/frozenui">FrozenUI</a></li>
<li><a href="https://github.com/ant-design/ant-design">Ant Design</a></li>
<li><a href="http://github.com/ant-design/ant-design-mobile">Ant Design Mobile</a></li>
<li><a href="https://github.com/huxiaoqi567/xscroll">XScroll</a></li>
<li><a href="https://github.com/driftyco/ionic">Ionic</a></li>
<li><a href="https://github.com/sdc-alibaba/SUI-Mobile">SUI Mobile</a></li>
<li><a href="https://github.com/dimsemenov/PhotoSwipe">PhotoSwipe</a></li>
</ul>
<h2>工具框架</h2>
<ul>
<li>世界上最好的语言 <code>JavaScript</code></li>
<li>啥都能做的前端构建工具 <a href="https://webpack.js.org/">Webpack</a></li>
<li>简单好用的文档展示工具 <a href="https://docute.js.org/#/">Docute</a></li>
</ul>
</div></template><script>
export default {
  head: {"title":"感谢 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// thanks-34.vue?191e3d9a